import styled from "styled-components";
import PropTypes from "prop-types";

import { bold as boldStyles, fonts, colors } from "./";

const FormFieldError = styled.span`
    color: ${colors.coral};
    ${({ size }) => fonts.typeScale[size]}
    ${({ bold }) => (bold ? boldStyles : null)}
`;

FormFieldError.propTypes = {
    size: PropTypes.number,
    bold: PropTypes.bool,
};

export { FormFieldError };
